import { render, staticRenderFns } from "./CMaterialType.vue?vue&type=template&id=bf5591f8"
import script from "./CMaterialType.vue?vue&type=script&lang=js"
export * from "./CMaterialType.vue?vue&type=script&lang=js"
import style0 from "./CMaterialType.vue?vue&type=style&index=0&id=bf5591f8&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf5591f8')) {
      api.createRecord('bf5591f8', component.options)
    } else {
      api.reload('bf5591f8', component.options)
    }
    module.hot.accept("./CMaterialType.vue?vue&type=template&id=bf5591f8", function () {
      api.rerender('bf5591f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CMaterialType.vue"
export default component.exports